<template>
    <div height="100%" width="25rem" class="px-0 card-nav">
        <v-navigation-drawer v-model="drawerCustom" v-if="drawerCustom" app>
            <template v-slot:prepend>
                <v-list-item two-line>
                    <v-list-item-avatar>
                        <img :src="logo">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ empresa }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>

            <!-- Primer nivel del menú -->
            <ul class="menu">
                <li v-for="(item, i) in itemsMenu" :key="'mn' + i" style="margin-top: 3px;">
                    <MenuItem :level="1" :item="item" :open="(itemOpen == i)"
                        @openItem="itemOpen = (itemOpen != i) ? i : null; subItemOpen = null">
                    </MenuItem>
                    <div v-if="item.submenus && item.submenus.length > 0 && itemOpen == i">
                        <ul class="submenu">
                            <li v-for="(subitem, j) in item.submenus" :key="'submn' + j" style="margin-top: 3px;">

                                <MenuItem :level="2" :open="(itemOpen == i && subItemOpen == j)" :item="subitem"
                                    @openItem="subItemOpen = (subItemOpen != j) ? j : null">
                                </MenuItem>
                                <div
                                    v-if="subitem.submenus && subitem.submenus.length > 0 && itemOpen == i && subItemOpen == j">
                                    <ul class="submenu">
                                        <li v-for="(subitem2, k) in subitem.submenus" :key="'sub2mn' + k"
                                            style="margin-top: 3px;">
                                            <MenuItem :level="3" :item="subitem2">
                                            </MenuItem>
                                        </li>
                                    </ul>
                                </div>

                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </v-navigation-drawer>
    </div>
</template>

<script>
import MenuItem from './MenuItem.vue';
export default {
    props: {
        drawer: { type: Boolean }
    },
    components: {
        MenuItem
    },
    data() {
        return {
            drawerCustom: true,
            itemOpen: null,
            subItemOpen: null,
            logo: process.env.VUE_APP_URL_YO + this.$store.state.user.Emp_Imagen,
            empresa: this.$store.state.user.Emp_Nombre,
            right: null,
            old: [
                { title: 'Inicio', icon: 'mdi-home', to: '/', submenus: [] },
                { title: 'Clientes', icon: 'mdi-card-account-details', to: '/AdminCustomers', submenus: [] },
                { title: 'Preguntas', icon: 'mdi-table-question', to: '/bag_quetions', submenus: [] },
                { title: 'Resultados', icon: 'mdi-message-bulleted', to: '/results', submenus: [] },
                {
                    title: 'Instalaciones',
                    icon: 'mdi-file-tree-outline',
                    submenus: [
                        { title: 'Administrar Instalaciones', to: '/installations' },
                    ]
                },
                {
                    title: 'Cuestionarios',
                    icon: 'mdi-calendar-question',
                    submenus: [
                        { title: 'Administrar Cuestionarios', to: '/adminQuestionnaires' },
                    ]
                },
                {
                    title: 'Encuestas',
                    icon: 'mdi-clipboard-list-outline',
                    submenus: [
                        { title: 'Administrar Encuestas', to: '/surveys' },
                    ]
                },
                {
                    title: 'Asignacion de Encuestas o Cuestionarios', icon: 'mdi-clipboard-account-outline', to: '/answers', submenus: [
                        { title: 'Asignar Grupo de Usuarios/Instalaciones a Cuestionarios', to: '/questionnaire_group_destiny' },
                        //{ title: 'Encuestas Asignadas a Encuestadores', to:'/roadmap'},
                    ]
                },
                {
                    title: 'Encuestadores',
                    icon: 'mdi-human-male-board-poll',
                    submenus: [
                        { title: 'Administrar Encuestadores', to: '/adminPollsters' },
                        { title: 'Grupos de Encuestadores', to: '/groups_pollsters' },
                    ]
                },
                {
                    title: 'Usuarios',
                    icon: 'mdi-account',
                    submenus: [
                        { title: 'Grupos de Usuarios', to: '/user_group' },
                    ]
                },
                {
                    title: 'Hojas de Ruta', icon: 'mdi-format-list-bulleted',
                    submenus: [
                        { title: 'Administrar Hojas', to: '/Roadmap' },
                        //{ title: 'Modificar HR',  to: '/editRoadmap'},
                    ]
                },
                //{ title: 'Resultados de Cuestionarios/Encuestas', icon: 'mdi-forum', to: '/answers', submenus:[] },
                {
                    title: 'Configuración',
                    icon: 'mdi-cog-outline',
                    submenus: [
                        { title: 'Tipos de Cuestionarios', to: '/typeQuestionnaires' },
                        { title: 'Categorías de Preguntas', to: '/questionCategories' },
                        { title: 'Tipos de Instalaciones', to: '/installationsTypes' },
                        { title: 'Feriados', to: '/holidays' },
                        {
                            title: 'Canales', submenus: [
                                { title: 'Canales son', to: '/channels' },
                            ]
                        },
                    ]
                },
                { title: 'Control de Migración de Datos', icon: 'mdi-file', to: '/imports', submenus: [] },
            ]
        }
    },
    computed: {
        itemsMenu() {
            return (this.$store.state.user.menu && this.$store.state.user.menu.length) ? this.$store.state.user.menu : this.old
        }
    },
    beforeMount() {
        this.asegurarLinkReporte()
        this.setActualRoute()
    },
    watch: {
        drawer(val) {
            this.drawerCustom = val
        },
        drawerCustom(val) {
            this.$emit('updateDrawer', val)
        },
        itemsMenu: {
            handler() {
                this.asegurarLinkReporte()
                this.setActualRoute()
            }, deep: true
        },
        '$store.state.user.Emp_Id'() {
            this.asegurarLinkReporte()
        },
        '$route.path'(val) {
            if (val != '/') this.setActualRoute()
            else {
                this.itemOpen = null
                this.subItemOpen = null
            }
        },
    },
    methods: {
        asegurarLinkReporte() {
            const to = '/results/respuestas-fotos'
            const visible = Number(this.$store.state.user.Emp_Id) === 4
            const menus = [this.old]
            if (this.$store.state.user.menu && this.$store.state.user.menu.length) {
                menus.push(this.$store.state.user.menu)
            }
            menus.forEach(menu => {
                const yaEsta = menu.findIndex(item => item.to === to)
                if (!visible) {
                    if (yaEsta >= 0) menu.splice(yaEsta, 1)
                    return
                }
                if (yaEsta >= 0) return
                const link = {
                    title: 'Reporte Respuestas Fotos',
                    icon: 'mdi-image-multiple',
                    to,
                    openInApp: true,
                    submenus: []
                }
                const resultados = menu.findIndex(item => item.to === '/results' || item.title === 'Resultados')
                if (resultados >= 0) menu.splice(resultados + 1, 0, link)
                else menu.push(link)
            })
        },
        openItem(event, index) {
            this.itemsMenu[index].open = event
            console.log(event)
        },
        setActualRoute() {
            this.itemsMenu.forEach((item, i) => {
                // Verificar primer nivel
                if (item.to && item.to === this.$route.path) {
                    this.itemOpen = i;
                    this.subItemOpen = null;
                    return;
                }

                if (item.submenus && item.submenus.length) {
                    item.submenus.forEach((submenu, j) => {
                        // Verificar segundo nivel
                        if (submenu.to && submenu.to === this.$route.path) {
                            this.itemOpen = i;
                            this.subItemOpen = j;  // ← ERA 'null', ahora es 'j'
                            return;
                        }

                        // Verificar tercer nivel
                        if (submenu.submenus && submenu.submenus.length) {
                            submenu.submenus.forEach((submenu2) => {
                                if (submenu2.to && submenu2.to === this.$route.path) {
                                    this.itemOpen = i;
                                    this.subItemOpen = j;
                                    return;
                                }
                            });
                        }
                    });
                }
            });
        }
    }
}
</script>

<style>
.card-nav .mdi-chevron-down::before {
    color: gray;
}

.card-nav .mdi-chevron-up::before {
    color: gray;
}

.v-application ul {
    padding-left: 0;
}

.menu {
    list-style-type: none;
    margin-inline: 5px;
    padding-inline: 5px;
}

.submenu {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.menu li {
    margin: 0;
}

.submenu li {
    margin: 0;
    padding-inline: 0;
}

/* width */
.v-navigation-drawer__content::-webkit-scrollbar {
    width: .5rem !important;
}

/* Track */
.v-navigation-drawer__content::-webkit-scrollbar-track {
    background: #f2f3f8 !important;
}

/* Handle */
.v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: #c3c3c3 !important;
    border-radius: 10px !important;
}
</style>
